import type { IntegrationName } from "@tellescope/tanstack-query";
import { cn } from "@tellescope/ui";
import { getAllIntegrationsMap } from "../../constants";
import type { Integration } from "../../types";

export interface IntegrationSelectionListItemProps {
  isSelected: boolean;
  onClick?: () => void;
  name: IntegrationName;
  className?: string;
}

export const IntegrationSelectionListItem = ({
  isSelected,
  onClick,
  name,
  className,
}: IntegrationSelectionListItemProps) => {
  const integration: Integration = getAllIntegrationsMap()[name];

  const bgColor = integration.color + "14"; // 20% opacity
  const bgHoverColor = integration.color + "1E"; // 30% opacity

  return (
    <button
      onClick={onClick}
      style={{
        "--border-color": integration.color,
        "--bg-color": bgColor,
        "--bg-hover-color": onClick ? bgHoverColor : bgColor,
      }}
      className={cn(
        "flex p-4 border items-center transition-all gap-3 rounded-md bg-white",
        isSelected && "border-[var(--border-color)] bg-[var(--bg-color)] hover:bg-[var(--bg-hover-color)]",
        className
      )}
      disabled={!onClick}
    >
      {integration.Icon ? (
        <integration.Icon className="p-2 bg-white border rounded-md size-10 text-gray-700" />
      ) : (
        <img src={integration.logoSrc} className="p-1 bg-white border rounded-md size-10" />
      )}
      <div className="space-y-1 text-left">
        <h4 className="font-medium text-gray-900">{integration.title}</h4>
        <p className="text-sm text-gray-600">{integration.description}</p>
      </div>
    </button>
  );
};
